import { useEffect } from "react";

import { usePlatformSimpleLogo } from "../api/queries/usePlatformSimpleLogo";
import faviconIco from "../assets/favicon.ico";

export function PlatformFavicon() {
  const { data: platformSimpleLogoUrl, isLoading } = usePlatformSimpleLogo();

  useEffect(() => {
    if (isLoading) return;

    const finalUrl = platformSimpleLogoUrl || faviconIco;
    const iconType = platformSimpleLogoUrl
      ? platformSimpleLogoUrl.includes(".svg")
        ? "image/svg+xml"
        : "image/png"
      : "image/x-icon";
    const iconLink =
      document.querySelector<HTMLLinkElement>('link[rel="icon"]') ??
      document.querySelector<HTMLLinkElement>('link[rel="shortcut icon"]');

    if (iconLink) {
      iconLink.type = iconType;
      iconLink.href = finalUrl;
      return;
    }

    const link = document.createElement("link");
    link.rel = "icon";
    link.type = iconType;
    link.href = finalUrl;
    document.head.appendChild(link);
  }, [platformSimpleLogoUrl, isLoading]);

  return null;
}
